import React from 'react';
import {
  DOCUMENT_OPTIONS,
  DOCS_FIELD_NAME,
  CUSTOM_DOCS_FIELD_NAME,
  CREATION_TYPE_FIELD_NAME,
  isSpreadsheetMethod,
} from '../../utils';
import RfiDocumentField from '../RfiDocumentField';
import StartFromTemplate from './components/StartFromTemplate';
import { useField } from 'react-final-form';
import AddCustomRfiDocument from '../AddCustomRfiDocument';
import StepImportSpreadsheet from '../StepImportSpreadsheet';
import { useTranslation } from 'react-i18next';
import {
  RfiCreateStep,
  DataRoomRFICreationType,
} from 'router/subrouters/DataRoom/models/DataRoomRfi';

const StepDocuments: React.FC<RfiCreateStep> = ({
  isCreatingOrEditingTemplate,
}) => {
  const { input: customDocumentsInput } = useField(CUSTOM_DOCS_FIELD_NAME);

  const {
    input: { value: creationType },
  } = useField<DataRoomRFICreationType>(CREATION_TYPE_FIELD_NAME);

  const { t } = useTranslation();

  if (isSpreadsheetMethod(creationType))
    return (
      <StepImportSpreadsheet
        isCreatingOrEditingTemplate={isCreatingOrEditingTemplate}
      />
    );

  return (
    <>
      <input hidden name={DOCS_FIELD_NAME} />
      <input hidden name={CUSTOM_DOCS_FIELD_NAME} />

      {!isCreatingOrEditingTemplate && <StartFromTemplate />}

      {DOCUMENT_OPTIONS.map(({ value, label }, index) => (
        <RfiDocumentField
          key={value}
          type={value}
          label={t(label)}
          name={`${DOCS_FIELD_NAME}[${index}]`}
        />
      ))}

      {customDocumentsInput?.value?.map((d: any, index: number) => (
        <RfiDocumentField
          key={d.name}
          type="other"
          label={d.name}
          name={`${CUSTOM_DOCS_FIELD_NAME}[${index}]`}
        />
      ))}

      <AddCustomRfiDocument name={CUSTOM_DOCS_FIELD_NAME} />
    </>
  );
};

export default StepDocuments;
